var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('el-button',{attrs:{"type":"primary"},on:{"click":_vm.downloadwechatPdf}},[_vm._v("打印退款申请单")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }